import React from 'react';
import { Eyebrow } from './Eyebrow';
import { BONUSES } from '../data/landing';
export function BonusSection() {
  return <section className="bg-cream-2 py-14 md:py-20" aria-labelledby="bonus-title" data-id="element-1" data-mp="1of2cpyhde67k">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-2" data-mp="22fwq6vj9yxd3">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-3" data-mp="22daimvwdwhuv">
          <Eyebrow data-id="element-4" data-mp="1yfct1rypbtqy">Incluidos hoy</Eyebrow>
          <h2 id="bonus-title" className="mt-4 text-[26px] leading-[1.15] sm:text-[34px] lg:text-[38px]" data-id="element-5" data-mp="1yc754g1t6xwt">
            Cinco herramientas adicionales. Incluidas sin coste extra.
          </h2>
        </div>

        <ul className="mt-8 grid gap-3 lg:grid-cols-5" data-id="element-6" data-mp="1jh0ypryswx2y">
          {BONUSES.map((bonus, index) => <li key={bonus.title} className="flex gap-3.5 overflow-hidden rounded-[12px] border border-line bg-carbon-card p-3 lg:flex-col lg:gap-0 lg:p-0" data-id="element-7" data-mp="1eozo0aha7ef1" data-mpi={index}>
              <img src={bonus.image} alt={`Portada del bonus ${index + 1}: ${bonus.title}`} width={1024} height={1024} loading="lazy" decoding="async" className="h-[86px] w-[86px] flex-none rounded-[8px] object-cover lg:h-auto lg:w-full lg:rounded-none" data-id="element-8" data-mp="mxtj7gqm8sjf" />
              <div className="flex flex-col lg:p-4" data-id="element-9" data-mp="2ohiokh91x6kj">
                <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-10" data-mp="2og7q8wydkr0t">
                  Bonus {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-1.5 text-[13px] font-bold leading-snug text-ink-light md:text-[14px]" data-id="element-11" data-mp="1vt3g6dkfdmi6">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-[12px] font-medium leading-relaxed text-ink-light/60 md:text-[13px]" data-id="element-12" data-mp="25q84ok1qtu25">
                  {bonus.text}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}